import { Injectable, LOCALE_ID, Inject, inject } from '@angular/core';
import { DatePipe } from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class DateService {

    constructor() {}

    static to8601String(d: string) : string {

        const offset = new Date(d).getTimezoneOffset();

        const a = offset < 0 ? '+' : '-';
        const b = (Math.abs(offset/60)+"").padStart(2, "0");
        const c = (Math.abs(offset%60)+"").padStart(2, "0");
        
        return `${d}T00:00:00${a}${b}:${c}`;
    };

    /*
    static toDateString(d: string | Date = new Date()) : string {

        d instanceof Date ? d.setHours(0,0,0,0) : '';
        const datePipe = new DatePipe('en-US');  
        return datePipe.transform(d, 'y-MM-dd') + "";
    }
    */

    static toDateString(d: string | Date = new Date()): string {

        // If it's a string, extract the leading YYYY-MM-DD and return it as-is
        if (typeof d === 'string') {
            const m = /^(\d{4}-\d{2}-\d{2})/.exec(d.trim());
            if (m) return m[1];
        }

        // If it's a Date (or any non-matching string), format using UTC to avoid TZ shifts
        const datePipe = new DatePipe('en-US');
        return (datePipe.transform(d, 'y-MM-dd', 'UTC') ?? '');
    }
}
